import React, { ReactNode } from 'react';
import { changeToZeroMoment } from '../timeHelpers';
import GeneralEnum from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { numberWithCommas } from '../format';

export const GroupIncentive = (data: { type?: string; list?: any }): { [key: string]: string | ReactNode }[] => {
    const showDataList: { [key: string]: string | ReactNode }[] = [];
    data.list.forEach((itList: any) => {
        const values = GeneralEnum ? GeneralEnum.getEnum(`BonusType`) : {};
        const typeValues: SelectObject[] = getValFromEnum(values);
        let valueBonusType: any = typeValues.find((it) => +it.value === +`${itList.bonusType}`);
        valueBonusType = valueBonusType ? valueBonusType.label : '';

        const showData: { [key: string]: string | ReactNode } = {
            id: itList.id,
            amount: itList.amount,
            bonusType: valueBonusType,
            bonusCaseNumber: itList.bonusCaseNumber,
            bonusDate: itList.bonusDate ? `${changeToZeroMoment(itList.bonusDate, 'MMM D, YYYY')}` : '', //
            bonusInfo: itList.bonusInfo,
            type: 'Bonus',
        };
        showDataList.push(showData);
    });

    return showDataList;
};
